import { Container, ListItemButton, ListItemText } from "@mui/material";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { setBreadcumbs, setIsShowBack, setTitle } from "../../../containers/containers.reducer";
import checkAccess from "../../../shared/checkAccess";
import CustomModal from "../../../shared/CustomModal";
import CustomTable from "../../../shared/CustomTable";
import notificationError from "../../../shared/notificationError";
import notificationSuccess from "../../../shared/notificationSuccess";
import { deleteRemoveTarget } from "../../absent/removeTarget/removeTarget.api";
import ReportRemoveTargetEdit from "./ReportRemoveTargetEdit";

export default function ReportRemoveTarget() {

    const dispatch = useDispatch()

    const [dataSelected, setDataSelected] = useState<any>({})
    const [modalEdit, setModalEdit] = useState(false)
    const [timeGetData, setTimeGetData] = useState<any>(undefined)

    useEffect(() => {
        dispatch(setTitle("Report"))
        dispatch(setIsShowBack(false))
        dispatch(setBreadcumbs([
            {
                name: "Report",
                url: ""
            },
            {
                name: "Remove Target Report",
                url: "/report/removetarget"
            }
        ]))
    }, [])

    const handleCloseModalEdit = (isReload: boolean) => {
        setModalEdit(false)
        if (isReload) {
            setTimeGetData(new Date().getTime())
        }
    }

    const handleDelete = (id: string) => {
        Swal.fire({
            icon: "question",
            title: "Are you sure to delete this data?",
            showCancelButton: true
        })
            .then(response => {
                if (response.isConfirmed) {
                    dispatch<any>(deleteRemoveTarget(id))
                        .unwrap()
                        .then((response: any) => {
                            if (response.status === 200) {
                                notificationSuccess("success delete remove target")
                                setTimeGetData(new Date().getTime())
                            }
                            else {
                                notificationError(response)
                            }
                        })
                }
            })
    }

    return (
        <Container maxWidth='xl'>
            <CustomModal
                open={modalEdit}
                onClose={handleCloseModalEdit}
                title="Edit Remove Target"
                component={
                    <ReportRemoveTargetEdit onClose={handleCloseModalEdit} data={dataSelected} />
                }
            />
            <CustomTable
                url={"/report/removetarget"}
                filterDate={true}
                columns={[
                    {
                        name: "Employee",
                        key: "employee_name",
                        sum: (props: any) => {
                            return 1
                        }
                    },
                    {
                        name: "Head",
                        key: "head_name"
                    },
                    {
                        name: "Remove Target Date",
                        key: "name",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    <span>
                                        {props.data.name ? moment(props.data.name).format('DD-MM-YYYY') : '-'}
                                    </span>
                                </td>
                            )
                        }
                    },
                    {
                        name: "Remove Target",
                        key: "value",
                        sum: (props: any) => {
                            return props.data.value
                        }
                    },
                    {
                        name: "Notes",
                        key: "notes"
                    },
                    {
                        name: "Status",
                        key: "status_name"
                    },
                    {
                        name: "Rejection Notes",
                        key: "notes_approval"
                    }
                ]}
                export={true}
                rowActions={(props: any) => (
                    <Fragment>
                        {checkAccess("EDIT") &&
                            <ListItemButton onClick={() => { setDataSelected(props.data); setModalEdit(true) }}>
                                <ListItemText>Edit</ListItemText>
                            </ListItemButton>
                        }
                        {checkAccess("DELETE") &&
                            <ListItemButton onClick={() => handleDelete(props.data.id)}>
                                <ListItemText>Delete</ListItemText>
                            </ListItemButton>
                        }
                    </Fragment>
                )}
                timeGetData={timeGetData}
            />
        </Container>
    )
}